import { Component, Input, ViewChild, OnInit, AfterViewInit, OnDestroy } from '@angular/core';


import {RestreamPlayerComponent} from '../../shared/components/restream-player/restream-player.component'
import {RestreamsService}  from "../../shared/services/restreams.service";
import {AuthService}  from "../../shared/services/auth.service";
import {RestreamProject, RestreamItem} from "../../shared/interfaces";
import { NbGlobalPosition, NbToastrService, NbDialogRef, NbComponentStatus } from '@nebular/theme';
import {SocketRestreamsOverview} from "../../shared/services/sockets";
import {Subject} from "rxjs";
import {domain, protocol} from '../../shared/config';
@Component({
  selector: 'app-overview-restreams-item',
  templateUrl: './overview-restreams-item.component.html',
  styleUrls: ['./overview-restreams-item.component.scss']
})
export class OverviewRestreamsItemComponent implements OnInit, OnDestroy,AfterViewInit {

  @Input() restream : RestreamProject;
  @Input() socket : SocketRestreamsOverview;
  @Input() eventEmitter : Subject<any>;


  @ViewChild('video') videoComponent:RestreamPlayerComponent 
 loaded = false
   
  domain: any = {
    name: domain, protocol
  }
  titleValue:string;
  restreams: RestreamItem[] ;
  saveDisabled:boolean = true;
  loading:boolean = true;
  onEvent$: any;
  save$:any = null ;

  constructor(
    private toastrService: NbToastrService,
    protected ref: NbDialogRef<OverviewRestreamsItemComponent>,
    private restreamsService : RestreamsService,
    private authService : AuthService
  ) { 
  }

  ngOnInit(): void {


    this.onEvent$ =   this.eventEmitter.subscribe(this.onEvent.bind(this))
  
 


    this.titleValue = this.restream.title
 
    this.loadData(<RestreamItem[]>this.restream.restreams.map(r => ({...r})))

    this.loaded = true

    this.updateRunnings()

  
  }

  loadData(restreams : RestreamItem[]){
    this.restreams = restreams
 /*   for (let i = this.restream.restreams.length; i< 20; i++){
      this.restreams.push(<RestreamItem>{  url: '',  key: '',   active: false,   login: '',   password: '' })
     } */

  
  }
  
  ngAfterViewInit(){
      this.videoComponent.start()
  }

  updateRunnings(){
    if( this.restream.runningList){
      for(let item of this.restreams){
        let candidate = this.restream.runningList.find(r=>{return r.id === item.id})
        if(candidate){
          item.running = true
        }else{
          item.running = false
        }
      }
    }
  }


  addItem(){
/* */
	if(this.restreams.length >= this.authService.restreamsLimit){

		this.showToast(`Перевищення ліміту потоків у поточному тарифі. Максимум ${this.authService.restreamsLimit}`, 'danger')
		return
	}

    this.restreams.push(<RestreamItem>{ unsaved : true, id : Date.now()+Math.random( )+'', url: '',  key: '',   active: true,   login: '',   password: '' })
    this.saveDisabled = false
    
  }

  deleteItem(item){
    this.restreams = this.restreams.filter(i=>{return i.id !== item.id})
    this.saveDisabled = false
  } 

  onEvent(data){
     
    if(data.type === 'updateRunnings'){
      this.updateRunnings()
      
         if(data.connected === true){
         
               this.videoComponent.start()
         } else if(data.connected === false && data.connected !== undefined){
               this.videoComponent.stop()
         
         }   
    }
    
     

  }

  isUrlValid(userInput) {
    var res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
   if(res == null)
       return false;
   else
       return true;
 }

 validate(restreams){
      /* */  if(restreams.length >  this.authService.restreamsLimit){

		this.showToast(`Перевищення ліміту потоків в поточному тарифі. Максимум ${this.authService.restreamsLimit}`, 'danger')
		return false
	} 
   let valid = true

   for (let restr of restreams ){

     delete restr.errorUrl
     delete restr.errorKey
     delete restr.errorLogin
     delete restr.errorPassword

     restr.url = restr.url.trim()
     restr.key = restr.key.trim()
     restr.login = restr.login.trim()
     restr.password = restr.password.trim()

     

     let validateKey = false
     if(restr.url !== '' ){
       if(!this.isUrlValid(restr.url)){
         valid = false
         restr.errorUrl = 'Невірний URL'
       }else{
         validateKey = true
       }
     }

     if(validateKey){
       if(restr.key === ''){
         valid = false
         restr.errorKey = 'Введіть RTMP ключ'
       }
     }

     if(restr.login !== ''  || restr.password !== '' ){
       if(restr.login === ''){
         valid = false
         restr.errorLogin = 'Введіть логін або видаліть пароль'

       }else  if(restr.password === ''){
         valid = false
         restr.errorPassword = 'Введіть пароль або видаліть логін'
       }
     }

   }


   return valid
 }


 changeRestreamRunningStatus(on, restream){

	if(restream.unsaved){
	 return
       }
    if(on){  
 
	 if(this.restreams.filter(r => r.running).length >=  this.authService.restreamsLimit){
 		this.showToast(`Перевищення ліміту потоків в поточному тарифі. Максимум${this.authService.restreamsLimit}`, 'danger')
		setTimeout(()=>{
		 restream.running = false;
		},1)	

		return false
	}

      this.socket.emit('restreamAction',{
        type: 'on',
        ident: this.restream._id,
        restreamId: restream.id
      })
    } else {
      this.socket.emit('restreamAction',{
        type: 'off',
        ident: this.restream._id, 
        restreamId: restream.id
      })
    }
 }
 

 getDataToSave(restreams){
   let arr:  RestreamItem[]  = []

   for (let restr of restreams ){
       if(  restr.url !== '' ||  restr.key !== '' ||  restr.login !== '' ||  restr.password !== ''  ){

   if(!restr.id){
   restr.id = Date.now()+Math.random( )+''

   }  
         arr.push({...restr})
       }
   }

   return arr
 }


 showToast(text, status = 'primary'){

  this.toastrService.show('',text,{
    status: <NbComponentStatus>status,
    icon: '',
    position: <NbGlobalPosition>'bottom-end'
      })
 } 



 showToastCopyClipboard(text){

  this.toastrService.show('',text,{
    status: 'primary',
    icon: '',
    position: <NbGlobalPosition>'bottom-end'
      })
 } 


 closeModal() {
  this.ref.close();
}


save(){
 
  if(!this.validate(this.restreams)){
    return
  }
  
  this.loading = true
 
  this.save$ = this.restreamsService.update(this.restream._id, this.getDataToSave(this.restreams), this.titleValue )
    .subscribe(
        (restream:RestreamProject)=>{
          this.restream.restreams = restream.restreams
             this.loadData((<RestreamItem[]>restream.restreams.map(r => ({...r})))) //stream.restreams.length ? stream.restreams.map(r => ({...r})) : this.getTemplate()
             this.restream.title = restream.title 
             this.updateRunnings()
             if(this.restream.hasSignal){

              this.socket.emit('restreamAction',{
                type: 'changeData',
                ident:this.restream._id,
                restreams: this.restreams
              })
            }
          //  this.onRestreamSaved(stream.restreams)
             this.toastrService.show('','Ретрансляція збережена',{
            status: 'success',
            position: <NbGlobalPosition>'bottom-end'
          })
          this.saveDisabled = true
      }, (error)=>{

          this.toastrService.show('','Сталася помилка збереження',{
            status: 'danger',
            position: <NbGlobalPosition>'bottom-end'
          })
      }, ()=>{
          this.loading = false
         
      }
    )



}


 ngOnDestroy() { 

  this.onEvent$.unsubscribe()
    if(this.save$){
      this.save$.unsubscribe()
      this.save$ = null
    }
 }

}
